<form name="editRole" (ngSubmit)="editRole()" #editRoleForm="ngForm" class="container pt-5">
    <div class="card text-bg-secondary mb-3 edit-role-card">
        <div class="card-body">
            <div class="container">
                <div class="row">
                    <div class="col"></div>
                    <div class="col-10">
                        <h1 class="card-header ps-0">EditRole</h1>
                    </div>
                    <div class="col"></div>
                </div>
                <div class="row">
                    <div class="col"></div>
                    <div class="col-10">
                        <div id="errorSummary"
                             class="text-danger"
                             [innerHTML]="errorList.outerHTML">
                        </div>
                        <div class="row mb-3">
                            <label for="roleId" class="col-sm-2 col-form-label">Role Id</label>
                            <div class="col-sm-10">
                                <input type="text"
                                       class="form-control"
                                       id="roleId"
                                       name="roleId"
                                       [value]="roleId"
                                       [(ngModel)]="model.id"
                                       #roleId="ngModel"
                                       [maxlength]="450"
                                       [required]="true"
                                       disabled>

                                <span id="roleIdErrorMsg"
                                      class="text-danger"
                                      *ngIf="roleId.invalid && (roleId.dirty || roleId.touched)">
                                    <span *ngIf="roleId.errors?.['required']">Role Id is required.</span>
                                    <span *ngIf="roleId.errors?.['maxlength']">
                                        The maximum length for role is 450 characters.
                                    </span>
                                </span>
                                <span id="serverRoleIdErrorMsg" class="text-danger">
                                    {{roleIdErrorMsg}}
                                </span>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <label for="roleName" class="col-sm-2 col-form-label">Role Name</label>
                            <div class="col-sm-10">
                                <input type="text"
                                       class="form-control"
                                       id="roleName"
                                       name="roleName"
                                       [value]="roleName"
                                       [(ngModel)]="model.roleName"
                                       #roleName="ngModel"
                                       [maxlength]="256"
                                       [required]="true">
                                <span id="roleNameErrorMsg"
                                      class="text-danger"
                                      *ngIf="roleName.invalid && (roleName.dirty || roleName.touched)">
                                    <span *ngIf="roleName.errors?.['required']">Role is required.</span>
                                    <span *ngIf="roleName.errors?.['maxlength']">
                                        The maximum length for role is 256 characters.
                                    </span>
                                </span>
                                <span id="serverRoleNameErrorMsg" class="text-danger">
                                    {{roleNameErrorMsg}}
                                </span>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <label for="roleDescription" class="col-sm-2 col-form-label">Description</label>
                            <div class="col-sm-10">
                                <input type="text"
                                       class="form-control"
                                       id="roleDescription"
                                       name="roleDescription"
                                       [value]="roleDescription"
                                       [(ngModel)]="model.description"
                                       #roleDescription="ngModel">
                                <span id="descriptionErrorMsg"
                                      class="text-danger"
                                      *ngIf="roleDescription.invalid && (roleDescription.dirty || roleDescription.touched)">
                                </span>
                                <span id="serverDescriptionErrorMsg" class="text-danger">
                                    {{descriptionErrorMsg}}
                                </span>
                            </div>
                        </div>

                        <button type="submit" class="btn btn-primary me-2">Update</button>
                        <a href="/list_roles" class="btn btn-secondary">Cancel</a>
                    </div>
                    <div class="col"></div>
                </div>
                <br />
                <div class="card">
                    <div class="card-header">
                        <h3>Users in this role</h3>
                    </div>
                    <div class="card-body">
                        @if (model.users != null && model.users.length > 0) {
                          @for (user of model.users; track user.userId) {
                            @if(user.isSelected){
                              <h5 class="card-title">{{ user.userName }}</h5>
                            }
                          }
                        } @else {
                        <h5 class="card-title">None at the moment</h5>
                        }
                    </div>

                    <div class="card-footer">
                        <a [href]="'/edit_users_in_role?roleId=' + model.id" class="btn btn-primary">Add or Remove Users From This Role</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
